// extracted by mini-css-extract-plugin
export default {"container":"project-credit_container__2W563","title":"project-credit_title__3TRiV","name":"project-credit_name__3_v0Z"};